import { render, staticRenderFns } from "./RbuSectionList.vue?vue&type=template&id=08b62e67"
import script from "./RbuSectionList.vue?vue&type=script&lang=js"
export * from "./RbuSectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports